"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMobileFirstValue = void 0;
// finds the value matching the mobile-first notation, definitions like {xs: 5, md: 20} will return 5 in viewport sm
var getMobileFirstValue = function getMobileFirstValue(definitions, viewport) {
  return definitions[["xs", "sm", "md", "lg", "xl"].reduce(function (acc, v) {
    if (definitions[v]) {
      acc.bestViewport = v;
    }
    if (viewport === v) {
      acc.finalViewport = acc.bestViewport;
    }
    return acc;
  }, {
    bestViewport: "",
    finalViewport: ""
  }).finalViewport];
};
exports.getMobileFirstValue = getMobileFirstValue;